export default __webpack_public_path__ + "static/media/Pauldron of the Steel Behemoth.56b45a69.jpg";